import styled from 'styled-components';
export var SelectContainer = styled.div.withConfig({
  displayName: "SelectContainer",
  componentId: "wv4dj5-0"
})(["position:relative;inline-size:100%;display:flex;align-items:center;"]);